import { IDepartment } from "../../models/AgentSkills/Department";

interface IProps {
    departments: Array<IDepartment>;
    agentDepartments: Array<number>;
    onChange: (updatedDepartments: Array<number>) => void;
}

const Departments = ({ departments, agentDepartments , onChange }: IProps) => {
    return (
        <>
            Departments 
            <hr />
            {departments.map((department: IDepartment, index: number) => {
                return (
                    <div key={index}>
                        <input
                            type="checkbox"
                            checked={agentDepartments.includes(department.id)}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const updatedDepartments = [...agentDepartments];
                                if (e.target.checked) {
                                    updatedDepartments.push(department.id);
                                } else {
                                    updatedDepartments.splice(updatedDepartments.indexOf(department.id), 1);
                                }
                                onChange(updatedDepartments);
                            }}
                        />
                        <span>{department.name}</span>
                    </div>
                );
            })}
        </>
    );
};
export default Departments;